import { Stack } from '@mui/material';
import React, { Dispatch, SetStateAction, useRef } from 'react';
import { useGetCohortCompositionQuery } from '../../../api/dashboardApiSlice';
import { useSelector } from 'react-redux';
import { selectSelectedDatabase } from '../../common/databaseSlice';
import DataTable from './DataTable';
import PieChart from './PieChart';
import BarChart from './BarChart';
import { useOutletContext } from "react-router-dom";

type Props = {
    view: string;
    setView: Dispatch<SetStateAction<"chart" | "table">>;
    data: any[];
}

enum ChartType {
    PIE = 'PIE',
    BAR = 'BAR',
}

const CohortDemographics: React.FC<Props> = () => {
    const database = useSelector(selectSelectedDatabase);
    const { view } = useOutletContext<any>();

    const { data } = useGetCohortCompositionQuery({ database });

    const tableChartViewportRef = useRef<HTMLDivElement>(null);

    const getBarChartList = () => {
        return Object.values(data || {})?.filter((chart: any) => chart.type === ChartType.BAR)
    }

    const getPieChartList = () => {
        return Object.values(data || {})?.filter((chart: any) => chart.type === ChartType.PIE)
    }

    const getList = () => {
        return Object.values(data || {});
    }

    const renderChart = (chart: any, index: number) => {
        if (view === "table") {
            return <DataTable
                key={index}
                selectedSessionFilter={undefined}
                title={chart?.title}
                rowData={chart?.data}
                columnDefs={[{
                    field: 'label',
                },
                { field: 'value' }]} />
        }
        if (chart.type == ChartType.PIE) {
            return (
                <PieChart
                    key={index}
                    data={chart?.data}
                    title={chart?.title}
                    selectedSessionFilter={undefined}
                    ddAvailable={false}
                    imagingData={[]}
                />
            )
        } else if (chart.type == ChartType.BAR) {
            return (
                <BarChart
                    key={index}
                    data={chart?.data}
                    source={chart?.source}
                    title={chart?.title}
                    selectedSessionFilter={undefined}
                    ddAvailable={false}
                    imagingData={[]}
                    cohort={true}
                    sessionInfoMap={{}}
                />
            )
        }
        return <></>
    }

    return (
        <Stack height={"calc(100% - 62px)"} gap={3}>
            {view === "table" ?
                <Stack
                    ref={tableChartViewportRef}
                    flexDirection="column"
                    overflow={"auto"}
                    width={"100%"}
                    paddingRight={3}
                >
                    <Stack>
                        {getList().map((item, index) => {
                            return renderChart(item, index);
                        })}
                    </Stack>
                </Stack>
                :
                <>
                    <Stack flexDirection={"row"} gap={3} overflow={"auto"} width={"100%"} paddingBottom={1}>
                        <Stack flexDirection="column" overflow={"auto"} flexGrow={1}
                            paddingRight={3}>
                            {getBarChartList()?.map((chart, index) => {
                                return renderChart(chart, index);
                            })}
                        </Stack>
                        <Stack flexDirection="column" overflow={"auto"} minWidth={"450px"} paddingRight={3}>
                            {getPieChartList()?.map((chart, index) => {
                                return renderChart(chart, index);
                            })}
                        </Stack>
                    </Stack>
                </>
            }
        </Stack>
    )
}

export default CohortDemographics;
